import React, {useState, useEffect} from 'react';
import {toast} from "react-toastify";
import copy from "copy-to-clipboard";
import {ConfirmModal} from "../../../utils/confirm/ConfirmModal";
import {formatErrors, roleTechnicalSpecialist} from "../../../constants";
import {manualSetCodeClientAction} from "../../../actions/clientAction";
import {useDispatch, useSelector} from "react-redux";

export function ClientLink({code, isHealth = false, isControl = false, responseIllness = "", isMsgSend = false, clientid = "", typeCode = 0}) {
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const user = useSelector(state => state.user.profile);

  const copyLink = () => {
    copy(link);
    toast.success("Ссылка скопирована в буфер обмена!", {position: toast.POSITION.BOTTOM_RIGHT});
  };
  
  const copyMsg = () => {
    copy(responseIllness);
    toast.success("Сообщение скопирована в буфер обмена!", {position: toast.POSITION.BOTTOM_RIGHT});
  };

  const handleManualSetCode = (id, typeCode) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(manualSetCodeClientAction(id, typeCode)).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Пользователь получил код для анкеты', {position: toast.POSITION.BOTTOM_RIGHT});
        window.location.reload();
      }).catch((e) => {
        setLoading(false);
        toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(e);
      });
    });
  };

  useEffect(() => {
    if (isHealth) {
      setLink(document.location.protocol + '//' + document.location.host + '/health-questionnaire/' + code);
    }
    if (isControl) {
      setLink(document.location.protocol + '//' + document.location.host + '/control/' + code);
    }
  }, [code, isHealth, isControl]);

  if (!code || !link) {
    if(user && (user.role_id === roleTechnicalSpecialist)){
      return <div className="tabs__wrapper">
        <div className="tabs__inner">
          <ConfirmModal trigger={<span className={"active-link"}>Получить ссылку для анкеты</span>} triggerWrap={false} title={"Получить ссылку для анкеты?"} handleOk={() => handleManualSetCode(clientid, typeCode)}/>
        </div>
      </div>;
    }else{
      return null;
    }
  }

  return <div className="tabs__wrapper">
    <span className="tabs__edit copy pointer" onClick={copyLink}>Копировать</span>
    <div className="tabs__inner">
      <div className="tabs__heading">Ссылка для клиента</div>
      <div className="tabs__value">{link}</div>
    </div>
    {isHealth && <React.Fragment>
    <div className="tabs__inner">
        <span className="tabs__edit copy pointer" onClick={copyMsg}>Копировать</span>
    </div>
    <div className="tabs__inner">
      <div className="tabs__heading">Сообщение клиенту {isMsgSend && <div className="msg-send">отправлено</div>}</div>
      <div className="tabs__value white-space">{responseIllness}</div>
    </div>
    </React.Fragment>}
  </div>;
}
